import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import withReducer from 'app/store/withReducer';
import clsx from 'clsx';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Grid from '@material-ui/core/Grid';
import { red } from '@material-ui/core/colors';
import Divider from '@material-ui/core/Divider';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Box from '@material-ui/core/Box';
import FuseScrollbars from '@fuse/core/FuseScrollbars';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Modal from '@material-ui/core/Modal';
// import endUsersAccounts from '../shared/endUsersAccounts';
import useRouter from '@fuse/hooks/useRouter';
import axios from "@fuse/utils/axios";
import FuseLoading from '@fuse/core/FuseLoading';
import { Menu, MenuItem } from '@material-ui/core';
// import { ReactComponent as Eye } from '../icons/eye.svg';
// import { ReactComponent as GridView } from '../icons/grid_view.svg';
// import { ReactComponent as ListView } from '../icons/list_view.svg';
// import { ReactComponent as SearchIcon } from '../icons/search.svg';
// import { ReactComponent as UploadIcon } from '../icons/upload.svg';
// import { ReactComponent as AssetIcon } from '../icons/block.svg';
// import { ReactComponent as ArrowIcon } from '../icons/arrow.svg';
import SvgIcon from "@material-ui/core/SvgIcon";

import laptopImg from "../../new.png"

const bull = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
  >
    •
  </Box>
);
import { dateReformatTo_mmm_dd_yyyy,formatDateInto_yyyy_mm_dd } from '@fuse/utils/dateOperations';

import ContractDetailsTab from '../Tabs/Contract';
import Incidents from '../Tabs/Incidents';
import Status from '../Tabs/Status';
import Files from '../Tabs/Files';
import Activities from '../Tabs/Activities';
import Information from '../Tabs/information';
import Application from '../Tabs/Applications';
import SubscriptionDetails from '../Tabs/subscription_details';

// import { usePageTitle } from '@fuse/hooks';
// import QuotesTab from './Tabs/Quotes';

const drawerWidth = 400;
const headerHeight = 200;

const views = ['List View', 'Grid View'];

const defaultCounts = { end_users: 0, locations: 0 };

const defaultSearches = { location: '', quote_indicator: '', quote_status: '', revenue: '', action: '' };

function Item(props) {
    const { sx, ...other } = props;
    return (
        <Box
            sx={{
                display: 'flex',
                p: 1,
                m: 1,
                bgcolor: '#101010',
                color: 'grey.300',
                border: '1px solid',
                borderColor: 'grey.800',
                borderRadius: 2,
                fontSize: '0.875rem',
                fontWeight: '700',
                ...sx,
            }}
            {...other}
        />
    );
}

const useStyles = makeStyles(theme => ({
    '@global': {
        '#fuse-main': {
            height: '100vh'
        }
    },
    root: {
        display: 'flex',
        flexDirection: 'row',
        minHeight: '100%',
        position: 'relative',
        padding:"0 20px",
        // flex: '1 1 auto',
        height: 'auto',
        backgroundColor: "#F3F4F6"
    },
    cardGen: {
        width: '20%',
        height:"100%"
        // border:"1px solid red"
    },
    topBg: {
        // backgroundImage: 'url("../../assets/images/backgrounds/header-bg.png")',
        backgroundColor: "#F3F4F6",
        backgroundSize: 'cover',
        // pointerEvents: 'none',
        padding: "10px"
    },
    topBgFixed: {
        height: headerHeight,
        // backgroundImage: 'url("../../assets/images/backgrounds/header-bg.png")',
        backgroundColor: theme.palette.primary.dark,
        backgroundSize: 'cover',
        pointerEvents: 'none'
    },
    contentCardWrapper: {
        padding:'0 10 10 10',
        // maxWidth: 1400,
        // display: 'flex',
        flexDirection: 'row',
        // flex: '1 0 auto',
        width: '100%',
        minWidth: '0',
        margin: '0 auto',
        // [theme.breakpoints.down('sm')]: {
        // 	padding: '16px 16px 0 16px'
        // },
        // [theme.breakpoints.down('xs')]: {
        // 	padding: '12px 12px 0 12px'
        // }
    },
    contentCard: {
        display: 'flex',
        position: 'relative',
        // flex: '1 1 100%',
        flexDirection: 'row',
        backgroundColor: theme.palette.background.paper,
        minHeight: 0,
        overflow: 'hidden',
        borderRadius: '2px 2px 0 0',
    },
    drawerPaper: {
        width: drawerWidth,
        maxWidth: '100%',
        overflow: 'hidden',
        height: '100%',
        [theme.breakpoints.up('md')]: {
            position: 'relative'
        }
    },
    contentWrapper: {
        display: 'flex',
        flexDirection: 'row',
        // flex: '1 1 100%',
        zIndex: 10,
        background: `linear-gradient(to bottom, ${fade(theme.palette.background.paper, 0.8)} 0,${fade(
            theme.palette.background.paper,
            0.6
        )} 20%,${fade(theme.palette.background.paper, 0.8)})`
    },
    content: {
        display: 'flex',
        // flex: '1 1 100%',
        minHeight: 0
    },
    avatar: {
        backgroundColor: red[500],
    },
    activeTab: {
        // borderBottom: "2px solid",
        // borderBottomLeftRadius: "0px !important",
        // borderBottomRightRadius: "0px !important",
        background:"rgba(107, 44, 87, 0.04);",
        borderRadius:"0",
    },
    formControl: {
    },
    pullRight: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        alignItems: "flex-end"
    },
    formControlMinWidth: {
        minWidth: 200,
    },
    buttonSquare: {
        borderRadius: '5px'
    },
    buttonSquarePadded: {
        borderRadius: '5px',
        // paddingBottom: "5px",
    },
    card: {
        borderRadius: "12px"
    },
    cardContainer: {
    },
    borderRightLight: {
        borderRight: "1px solid rgba(0,0,0,0.12)"
    },
    buttonSquare: {
        borderRadius: '5px'
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    tabButton:{
        padding:"initial 20px"
    },
     pos: {
    marginBottom: 30,
  },
  btn:{
    background:"#30C90A",
    width:"120px",
    borderRadius:"17px",
    color:"#fff"
  },
  icon:{
   fontSize:"18px",
    color:"#61656F",
    display:"inline-block"
  }
}));

function TabButton(props) {
    const { activeClass, tab, tabState, tabStateChange, ...restProps } = props;

    const isActive = tab == tabState;

    return (
        <Button {...restProps} onClick={() => tabStateChange(tab)} className={restProps.className && isActive ? activeClass : ""}>
            {props.children}
        </Button>
    )
}

function TabContainer(props) {

    const { tabState, tab } = props;

    const shouldRender = tab == tabState;

    return shouldRender ? props.children : <></>
}

function AssetDetailsV4(props) {
    const router = useRouter()

    const id = router.params.id
    const source = router.params.source

    const dispatch = useDispatch();
    const [selectedView, setSelectedView] = useState(0);
    const [counts, setCounts] = useState(defaultCounts);
    const [quotes, setQuotes] = useState([]);
    const [companyInitial, setCompanyInitial] = useState('');
    const [searches, setSearches] = useState(defaultSearches);
    const classes = useStyles(props);
    const [loading, setLoading] = useState(false);
    const [endUsersAccountsMod, setEndUsersAccounts] = useState([]);
    const [assetDetails, setAssetDetails] = useState({});
    const [anchorEl, setAnchorEl] = useState(null);
    const [viewMenuOpened, setViewMenuOpened] = useState(false);

    const [tabState, setTabState] = useState("contract_details");
    const [open, setOpen] = useState(false)
    // const updatePageTitle = usePageTitle(dispatch);

    const [assetType, setAssetType] = useState({
        hardware:false,
        software_subscription : false,
        software_license : false
    })

    useEffect(()=>{
        if(assetType.hardware) setTabState('status')
        else setTabState('contract_details')
    },[assetType])

    const gridSize = (assetType.hardware && 6) || (!assetType.hardware && 12)

    const getAssetDetails = () => {
        setLoading(true)
        axios.get(`/assets/${id}`).then(res => {
            let data = res.data.data;
            const flattened = flattenAssetDetails(data);
            // console.log('242: ',flattened);
            setAssetType(prevState=>({
                ...prevState,
                [flattened.asset_type] : true
            }));

            setAssetDetails(flattened);

        }).catch(err => {
            return err;
        }).finally(() => {
            setLoading(false);
        })

        
    }

    const manuallyAddedAssetDetails = () => {
        setLoading(true)
        axios.get(`/assets/hardware-asset-details/${id}`).then(res => {
            let data = res.data.data
            // console.log('280=>',data)
            const flattenData = flattenManuallyAddedAssets(data)
            setAssetDetails(flattenData)
            setAssetType(state => ({...state, hardware: true}))
        }).catch(err => {
            return err
        }).finally(() => {
            setLoading(false)
        })
    }

    const flattenManuallyAddedAssets = (data) => {
        if(!data) return data
        return ({
            asset_name: 'N/A',
            asset_type: 'hardware',
            model: data['model.model_name'],
            warranty_end_date: data['warranty_end_date'],
            install_date: data['install_date'],
            eol: data['eol'],
            eosl: data['eosl'],
            serial_number: data['serial_number'],
            asset_manufacturer: { manufacturer_name: data['model.manufacturer.manufacturer_name']},
            shipping: {
                location_name: data['shipping.location_name'],
                address1: data['shipping.address1'],
                address2: data['shipping.address2'],
                country: data['shipping.country'],
                state: data['shipping.state'],
                city: data['shipping.city'],
                zip: data['shipping.zip']
            },
            image_link: data['image_location']
        })
    }

    useEffect(() => {
        // updatePageTitle("Asset Profile");
        if( source !== 'manual') {
            getAssetDetails()
        } else{
            manuallyAddedAssetDetails()
        }

        
    }, []);

    function flattenAssetDetails(accDetail) {
        let accRef = accDetail;
        let modObj = {};
        let dynAttr = {};
        let keys = Object.keys(accRef);
        for (let i = 0; i < keys.length; i++) {
            if (keys[i] != 'created_at' && keys[i] != 'updated_at' && keys[i] != 'platform_customer_id') {
                if (keys[i] != 'dynamic_attributes') {
                    if(keys[i] == 'status'){
                        //change property name 'status' to 'ASSETS_STATUS' because a dynamic filed has also named 'status' so it's overwrite the status value
                        modObj['ASSETS_STATUS'] = accRef[keys[i]]; 
                    }else{
                        modObj[keys[i]] = accRef[keys[i]];
                    }
                } else {
                    dynAttr = accRef[keys[i]];
                }
            }
        }

        if (Object.keys(dynAttr).length > 0) {
            keys = Object.keys(dynAttr);
            for (let i = 0; i < keys.length; i++) {
                if (keys[i] != 'id' && keys[i] != 'created_at' && keys[i] != 'updated_at') {
                    modObj[keys[i]] = dynAttr[keys[i]]['attribute_value'];
                }
            }
        }
        return modObj;
    }

    function handleViewMenuOpen(event) {
        setAnchorEl(event.currentTarget);
        setViewMenuOpened(true);
    }

    function handleViewMenuClose() {
        setAnchorEl(null);
        setViewMenuOpened(false);
    }

    function getLocations() {
        const locationSet = new Set();
        for (let i = 0; i < quotes.length; i++) {
            locationSet.add(quotes[i].location_name);
        }
        return Array.from(locationSet);
    }

    function getIndicators() {
        const indicatorSet = new Set();
        for (let i = 0; i < quotes.length; i++) {
            indicatorSet.add(quotes[i].indicator);
        }
        return Array.from(indicatorSet);
    }

    function getStatuses() {
        const statusSet = new Set();
        for (let i = 0; i < quotes.length; i++) {
            statusSet.add(quotes[i].status);
        }
        return Array.from(statusSet);
    }

    function getRevenues() {
        const revenueSet = new Set();

        for (let i = 0; i < quotes.length; i++) {
            revenueSet.add(quotes[i].quote_amount);
        }

        return Array.from(revenueSet);
    }

    function handleSearch(search) {
        // console.log(search)
        setSearches(search);
        // console.log(searches);
        const quotesMod = quotes.filter(quote => {
            if (searches.location != '' && quote.location_name != searches.location) {
                return false;
            }

            if (searches.quote_indicator != '' && quote.indicator != searches.quote_indicator) {
                return false;
            }

            if (searches.quote_status != '' && quote.status != searches.quote_status) {
                return false;
            }

            if (searches.revenue != '' && quote.quote_amount != searches.revenue) {
                return false;
            }

            if (searches.action != '' && quote.action != searches.action) {
                return false;
            }

            return true;
        });
        // console.log(quotesMod);
        setQuotes(quotesMod);
    }

    function clearSearch() {
        setSearches(defaultSearches);
        setQuotes(endUsersAccounts);
    }

    function gotoContacts(e) {
        //console.log(e.target.value, parseInt(router.params.id));
        var id = parseInt(router.params.id);
        router.push(`/company/${id}/end-users`)
    }

    function formatString(str){
        if(str){
            return str.split('_').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ')
        }
    }

    if (loading) {
        return (
            <FuseLoading />
        )
    }

    const showAssetImage = (assetName => {
        // console.log(assetName);
        if(assetName.includes('48 Ports') || assetName.includes('48 ports')){
            return 'https://webobjects2.cdw.com/is/image/CDW/6140005?$product_search_result$'
        }
        else if(assetName.includes('24 Ports') || assetName.includes('24 ports')){
            return 'https://webobjects2.cdw.com/is/image/CDW/6514146?$product_search_result$'
        }
        else if(assetName.includes('16 Ports') || assetName.includes('16 ports')){
            return 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSxrH4To9j0qImtEP2khpmlhCCZO62ljS-Dujc7G__yWhH3CNmDSDXZJcN9cfp_2eBE5-A&usqp=CAU'
        }
        else if(assetName.includes('12 Ports') || assetName.includes('12 ports')){
            return 'https://webobjects2.cdw.com/is/image/CDW/3602320?wid=1288&hei=923&resMode=bilin&fit=fit,1'
        }
        else if(assetName.includes('8 Ports') || assetName.includes('8 ports')){
            return 'https://webobjects2.cdw.com/is/image/CDW/3609453?wid=1288&hei=923&resMode=bilin&fit=fit,1'
        }
        else if(assetName.includes('Microsoft Office') || assetName.includes('microsoft office')){
            return 'https://webobjects2.cdw.com/is/image/CDW/2409958?$product-detail$'
        }
        else if(assetName.includes('SOTI') || assetName.includes('Soti')){
            return 'https://cdn.cnetcontent.com/6b/70/6b70b6df-29db-44a6-8e43-a49652bff93f.jpg' 
        }
        else if(assetName.includes('IGEL Enterprise') || assetName.includes('igel enterprise')){
            return 'https://webobjects2.cdw.com/is/image/CDW/5526545?$product_search_result$' 
        }
        else if(assetName.includes('teklynx') || assetName.includes('Teklynx')){
            return 'https://webobjects2.cdw.com/is/image/CDW/6563881?$product-detail$' 
        }
        else if(assetName.includes('Label Matrix') || assetName.includes('label matrix')){
            return 'https://webobjects2.cdw.com/is/image/CDW/6809637?$product_search_result$'
        }
        else if(assetName.includes('VMware') || assetName.includes('vmware')){
            return 'https://webobjects2.cdw.com/is/image/CDW/1955131?$product_search_result$'
        }
        else if(assetName.includes('Fortinet') || assetName.includes('FortiNet') || assetName.includes('fortinet') || assetName.includes('fortigate') || assetName.includes('Fortigate') || assetName.includes('FortiGate')){
            return 'https://4.imimg.com/data4/QC/EB/MY-11467452/fortigate-900d-500x500.png'
        }
        else if(assetName.includes('oracle') || assetName.includes('Oracle')){
            return 'https://webobjects2.cdw.com/is/image/CDW/3973219?$product-detail$'
        }
        else if(assetName.includes('Catalyst') || assetName.includes('catalyst')){
            return 'https://5.imimg.com/data5/SELLER/Default/2021/6/JT/KY/TG/6031200/cisco-used-ws-c2960x-48fpd-l-for-sale-in-bangalore-500x500.jpg'
        }
        else if(assetName.includes('HP') || assetName.includes('hp') || assetName.includes('Proliant') || assetName.includes('PROLIANT') || assetName.includes('ProLiant')){
            return 'https://i.pcmag.com/imagery/reviews/04QOe3T7rEoFGd3kiKw36TK-3.fit_scale.size_1028x578.v1569480646.jpg'
        }
        else{
            return 'data:image/png;base64,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'
        }
    })

    function showAssetImageRespectToSKU(image_link){
        // if(hardware_sku.includes('AP21-US')){
        //     return 'https://m.media-amazon.com/images/I/419mxFOd4bL._SL1000_.jpg'
        // }
        // else if(hardware_sku.includes('AP32-US')){
        //     return 'https://webobjects2.cdw.com/is/image/CDW/6197934?$product-detail$'
        // }
        // else if(hardware_sku.includes('AP12-US')){
        //     return 'https://www.juniper.net/content/dam/www/assets/images/us/en/products/access-points/ap12/mist-ap12-ports.png/jcr:content/renditions/cq5dam.web.1280.1280.png'
        // }
        // else if(hardware_sku.includes('EX2300-48P')){
        //     return 'https://witoni.com/wp-content/uploads/2020/09/juniper-ex2300-48t-switch.jpg'
        // }
        // else if(hardware_sku.includes('EX2300-24P')){
        //     return 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRHhCYEvF1DSsNS-NC3535Ql3YwRz5IFf7cZl3oZeJc8Ul5Q9HiG-G94uv5CC118G_Tzw&usqp=CAU'
        // }
        // else if(hardware_sku.includes('TC520K')){
        //     return 'https://webobjects2.cdw.com/is/image/CDW/6165576?$product-detail$'
        // }
        // else if(hardware_sku.slice(-2) === 'MO' || hardware_sku.includes('MO')){
        //     return 'https://webobjects2.cdw.com/is/image/CDW/3446215?$product-detail$'
        // }
        // else if(hardware_sku.includes('SSS')){
        //     return 'https://webobjects2.cdw.com/is/image/CDW/6704254?$product-detail$'
        // }
        // else if(hardware_sku.includes('ZT')){
        //     return 'https://webobjects2.cdw.com/is/image/CDW/4746983?$product-detail$'
        // }
        // else if(hardware_sku.includes('SOTI')){
        //     return 'https://rmsomega.com/wp-content/uploads/2015/02/soti_logo_webres-transparent.png'
        // }
        // else if(hardware_sku.slice(0,2) === 'DS'){
        //     return 'https://webobjects2.cdw.com/is/image/CDW/4365747?$product-detail$'
        // }
        // else if(hardware_sku.includes('MY')){
        //     return 'https://webobjects2.cdw.com/is/image/CDW/7061604?$product-detail$'
        // }
        // else if(hardware_sku.includes('EX')){
        //     return 'https://webobjects2.cdw.com/is/image/CDW/4174671?$product-detail$'
        // }
        if(image_link){
            return image_link
        }
        else{
            return 'data:image/png;base64,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'
        }
    }

    return (
       <>
        <div className={clsx(classes.root)}>
            <Modal
                open={open}
                onClose={()=>setOpen(false)}
                className={classes.modal}
            >
                <div style={{height:500,width:500,backgroundColor: 'white',borderRadius:9}}>
                    <img src={showAssetImageRespectToSKU(assetDetails.image_link)}/>
                </div>
            </Modal>

        

            <FuseScrollbars className="flex-grow overflow-x-auto">

                <div className={classes.topBg}>
                        <div style={{width: '100%'}}>
                            <Grid container spacing={1}>

                                <Grid item lg={8} style={{padding:"10px"}}>
                                  <Card style={{ height: "100%",borderRadius:"0",padding:"10px 0" }}>

                                    <Grid container spacing={2} style={{height:"100%"}}>
                                       <Grid item lg={5} style={{display:"flex",justifyContent:"center"}} 
                                    
                                       > 
                                            <CardMedia
                                            component="img"
                                            style={{transform:"translate(8px,0)",objectFit:"unset"}}
                                            image={laptopImg}
                                            alt="laptop image"
                                        />
                                        {/* <img src={laptopImg} alt="" /> */}
                                        </Grid>  

                                        <Grid item lg={7}>
                                             {/* <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    p: 1,
                    m: 1,
                    bgcolor: 'background.paper',
                    borderRadius: 1,
                }}
            >
                <Item>Item 1</Item>
                <Item>Item 2</Item>
                <Item>Item 3</Item>
            </Box> */}
                                             <CardContent>
                                       <div style={{display:"flex",justifyContent:"space-between"}}>
                                        <div>
                                            <Typography sx={{ fontSize: 14 }} color="textSecondary" gutterBottom style={{color:"#8A8E97",fontWeight:"600"}}>
                                            ASSET NAME
                                            </Typography>
                                            <Typography variant="h6" className={classes.pos} component="div">
                                            AP-MTL-HQ-AP09
                                            </Typography>
                                            </div>
                                        <div>
                                              <Button variant="contained" className={classes.btn}>
                                                    <Icon className="text-white mr-5" fontSize="default"><span class="material-symbols-outlined">
                                            wifi_tethering
                                            </span></Icon> Connected
                                            </Button>
                                        </div>
                                       
                                       </div>
                                        <Typography  color="textSecondary" style={{display:"flex",marginBottom:"5px"}}>
                                        <Icon>
                                            <span class="material-symbols-outlined" className={classes.icon}>
                                                list_alt
                                                </span>
                                            
                                        </Icon>
                                        <span style={{fontSize:"15px",color:"#61656F"}}>Serial No : </span><span style={{color:"#000",display:"inline-block",fontSize:"15px",marginLeft:"10px"}}>A072920070557</span>
                                        </Typography>
                                        <Typography variant="body2" style={{display:"flex",marginBottom:"5px"}}>
                                        <Icon>
                                            <span class="material-symbols-outlined" className={classes.icon}>
                                            photo
                                            </span>
                                            </Icon>
                                            <span style={{fontSize:"15px",color:"#61656F"}}>Model : </span><span style={{color:"#000",display:"inline-block",fontSize:"15px",marginLeft:"10px"}}>Laptop-AP43</span>
                                       
                                        </Typography>
                                         <Typography  style={{display:"flex",marginBottom:"5px"}} color="textSecondary">
                                        <Icon>
                                            <span class="material-symbols-outlined" className={classes.icon}>
                                                list_alt
                                                </span>
                                        </Icon>
                                        <span style={{fontSize:"15px",color:"#61656F"}}>Manufacturer : </span><span style={{color:"#000",display:"inline-block",fontSize:"15px",marginLeft:"10px"}}>Dell</span>
                                        </Typography>
                                          <Typography  style={{display:"flex",marginTop:"20px"}} color="textSecondary">
                                        <Icon>
                                            <span class="material-symbols-outlined" className={classes.icon}>
                                                list_alt
                                                </span>
                                        </Icon>
                                        <span style={{fontSize:"15px",color:"#61656F"}}>Subscription Status : </span><span style={{color:"#30C90A",display:"inline-block",fontSize:"15px",marginLeft:"10px"}}>Active</span>
                                        </Typography>
                                    </CardContent>
                                        </Grid>
                                    </Grid>
                                     {/* <CardMedia
                                     style={{width:"100px"}}
                                            component="img"
                                            // height="100"
                                            image={laptopImg}
                                            alt="laptop image"
                                        />
                                    <CardContent>
                                        <Typography sx={{ fontSize: 14 }} color="textSecondary" gutterBottom>
                                        Word of the Day
                                        </Typography>
                                        <Typography variant="h5" component="div">
                                        be{bull}nev{bull}o{bull}lent
                                        </Typography>
                                        <Typography sx={{ mb: 1.5 }} color="textSecondary">
                                        adjective
                                        </Typography>
                                        <Typography variant="body2">
                                        well meaning and kindly.
                                        <br />
                                        {'"a benevolent smile"'}
                                        </Typography>
                                    </CardContent> */}
                                  </Card>

                                </Grid>
                                
                                { assetType.hardware && 
                                <Grid item lg={4} md={6} sm={6} xs={6} style={{"pointerEvents": "all",maxWidth:'100%',padding:"10px"}}>
                                    <Card className={classes.card} style={{ height: "100%",borderRadius:"0" }}>
                                        <CardContent className={classes.cardContainer}>
                                            <div className="mt-5" style={{ display: "flex" }}>
                                                <Icon className="text-red-400 mt-2 mr-5" fontSize="default">location_on_outlined</Icon>
                                                <h2>
                                                    Asset Location
                                                </h2>
                                            </div>
                                            <div className="mt-10">
                                                <div className="m-5" style={{ alignItems: "center", flex: 1 }}>
                                                    {[assetDetails?.shipping?.location_name, assetDetails?.shipping?.address1, assetDetails?.shipping?.address2, assetDetails?.shipping?.city, assetDetails?.shipping?.state, assetDetails?.shipping?.zip, assetDetails?.shipping?.country].filter(item => item).join(", ")}
                                                </div>
                                                <div className="m-5 mt-10" style={{ flex: 2 }}>
                                                    <iframe width="100%" height="120" src={`https://maps.google.com/maps?q=${encodeURIComponent([assetDetails?.shipping?.address1, assetDetails?.shipping?.address2, assetDetails?.shipping?.city, assetDetails?.shipping?.state, assetDetails?.shipping?.zip, assetDetails?.shipping?.country].filter(item => item).join(","))}&t=&z=13&ie=UTF8&iwloc=&output=embed`} frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0"></iframe>
                                                </div>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                }
                            </Grid>
                        </div>
                </div>

                 
             
                <div className={classes.topBg} >
                     
                    <Grid container spacing={1} style={{flexDirection: !assetType.hardware ? 'column-reverse' : 'row'}}>
                        <div style={{ width: '100%',padding:"0 10px"}}>
                            <div className={clsx(classes.contentCardWrapper)}>
                                <div className={clsx(classes.contentCard, 'shadow')} style={{ width: "100% !important" }}>
                                    <main style={{ width: "100%" }}>
                                        <div style={{display:"flex",justifyContent:"space-between"}}>
                                            <div className={`${classes.cardGen}`}>
                                                <Card style={{borderRadius:'0',boxShadow:"none"}}>
                                                    <CardActions disableSpacing style={{display:"flex",flexDirection:"column",borderRadius:'0',boxShadow:'none'}}>
                                                        {assetDetails.asset_type !== 'hardware' ? 
                                                            <TabButton
                                                                tab="contract_details"
                                                                tabState={tabState}
                                                                tabStateChange={setTabState}
                                                                activeClass={classes.activeTab}
                                                                variant="text"
                                                                color="primary"
                                                                className={`w-full d-flex justify-content-start ${classes.tabButton}`}
                                                                style={{width:"100%",margin:"5px 0",display:"flex",justifyContent:"start"}}
                                                                >
                                                                Contract details
                                                            </TabButton>
                                                            :
                                                            <TabButton
                                                                tab="status"
                                                                tabState={tabState}
                                                                tabStateChange={setTabState}
                                                                activeClass={classes.activeTab}
                                                                variant="text"
                                                                color="primary"
                                                                className={`w-full d-flex justify-content-start ${classes.tabButton}`}
                                                                style={{width:"100%",margin:"5px 0",display:"flex",justifyContent:"start"}}
                                                               >
                                                                Status
                                                            </TabButton>
                                                        }
                                                        {
                                                            assetDetails.asset_type == 'hardware' &&
                                                            <TabButton
                                                                tab="information"
                                                                tabState={tabState}
                                                                tabStateChange={setTabState}
                                                                activeClass={classes.activeTab}
                                                                variant="text"
                                                                color="primary"
                                                                className={`w-full d-flex justify-content-start ${classes.tabButton}`}
                                                                style={{width:"100%",display:"flex",justifyContent:"start",margin:"5px 0"}}
                                                                >
                                                                Information
                                                            </TabButton>
                                                        }
                                                        {
                                                            assetDetails.asset_type == 'hardware' &&
                                                            <TabButton
                                                                tab="subscription_details"
                                                                tabState={tabState}
                                                                tabStateChange={setTabState}
                                                                activeClass={classes.activeTab}
                                                                variant="text"
                                                                color="primary"
                                                                className={`w-full d-flex justify-content-start ${classes.tabButton}`}
                                                                style={{width:"100%",display:"flex",justifyContent:"start",margin:"5px 0"}}
                                                                >
                                                                Subscription Details
                                                            </TabButton>
                                                        }
                                                        <TabButton
                                                            tab="incidents"
                                                            tabState={tabState}
                                                            tabStateChange={setTabState}
                                                            activeClass={classes.activeTab}
                                                            variant="text"
                                                            color="primary"
                                                            className={`w-full d-flex justify-content-start ${classes.tabButton}`}
                                                            style={{width:"100%",margin:"5px 0",display:"flex",justifyContent:"start"}}
                                                           >
                                                            Incidents
                                                        </TabButton>
                                                        {
                                                            assetDetails.asset_type == 'hardware' &&
                                                            <TabButton
                                                                tab="applications"
                                                                tabState={tabState}
                                                                tabStateChange={setTabState}
                                                                activeClass={classes.activeTab}
                                                                variant="text"
                                                                color="primary"
                                                                className={`w-full d-flex justify-content-start ${classes.tabButton}`}
                                                                style={{width:"100%",display:"flex",justifyContent:"start",margin:"5px 0"}}
                                                                >
                                                                Applications
                                                            </TabButton>
                                                        }
                                                        {
                                                            assetDetails.asset_type == 'hardware' &&
                                                            <TabButton
                                                                tab="files"
                                                                tabState={tabState}
                                                                tabStateChange={setTabState}
                                                                activeClass={classes.activeTab}
                                                                variant="text"
                                                                color="primary"
                                                                className={`w-full d-flex justify-content-start ${classes.tabButton}`}
                                                                style={{width:"100%",display:"flex",justifyContent:"start",margin:"5px 0"}}
                                                                >
                                                                Files
                                                            </TabButton>
                                                        }
                                                        {assetDetails.asset_type !== 'hardware' ? 
                                                            <TabButton
                                                                tab="system_information"
                                                                tabState={tabState}
                                                                tabStateChange={setTabState}
                                                                activeClass={classes.activeTab}
                                                                variant="text"
                                                                color="primary"
                                                                className={`w-full d-flex justify-content-start ${classes.tabButton}`}
                                                                style={{width:"100%",display:"flex",justifyContent:"start",margin:"5px 0"}}
                                                                >
                                                                System information
                                                            </TabButton>
                                                            :
                                                            <TabButton
                                                                tab="activities"
                                                                tabState={tabState}
                                                                tabStateChange={setTabState}
                                                                activeClass={classes.activeTab}
                                                                variant="text"
                                                                color="primary"
                                                                className={`w-full d-flex justify-content-start ${classes.tabButton}`}
                                                                style={{width:"100%",display:"flex",justifyContent:"start",margin:"5px 0"}}
                                                                >
                                                                Activities
                                                            </TabButton>
                                                        }
                                                    </CardActions>
                                                </Card>
                                            </div>
                                            {assetDetails?.id && (
                                                <div className={classes.cardGen} style={{ width: "79%" }}>
                                                    <Card className={classes.card} style={{ width: "100%",height:393}}>
                                                        <CardContent className={classes.cardContainer} style={{ width: "100%" }}>
                                                            <TabContainer tab="contract_details" tabState={tabState}>
                                                                <ContractDetailsTab assetId={assetDetails?.id} contractId={assetDetails?.contract?.id} />
                                                            </TabContainer>
                                                            <TabContainer tab="incidents" tabState={tabState}>
                                                                <Incidents assetDetails={assetDetails} />
                                                            </TabContainer>
                                                            <TabContainer tab="system_information" tabState={tabState}>
                                                                System information
                                                            </TabContainer>
                                                            <TabContainer tab="status" tabState={tabState}>
                                                                <Status />
                                                            </TabContainer>
                                                            <TabContainer tab="files" tabState={tabState}>
                                                                <Files />
                                                            </TabContainer>
                                                            <TabContainer tab="activities" tabState={tabState}>
                                                                <Activities />
                                                            </TabContainer>
                                                            <TabContainer tab="information" tabState={tabState}>
                                                                <Information />
                                                            </TabContainer>
                                                            <TabContainer tab="applications" tabState={tabState}>
                                                                <Application />
                                                            </TabContainer>
                                                            <TabContainer tab="subscription_details" tabState={tabState}>
                                                                <SubscriptionDetails />
                                                            </TabContainer>
                                                        </CardContent>
                                                    </Card>
                                                </div>
                                            )}
                                        </div>
                                    </main>
                                </div>
                            </div>
                        </div>

                    {/* <div>
                        <Box>

                            <Grid container spacing={3}>
   <Grid item lg={6}>
                                        <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Consectetur, sunt ducimus officia esse ullam, officiis earum expedita sapiente molestiae numquam quis quia impedit beatae id? Quaerat, quod? Consequatur officia est cum quasi at laboriosam odio voluptas placeat, illum nostrum earum suscipit modi quis eum animi eius dignissimos nobis, laborum blanditiis.</p>
                                </Grid>
                               
                                  <Grid item lg={6}>
                                        <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Consectetur, sunt ducimus officia esse ullam, officiis earum expedita sapiente molestiae numquam quis quia impedit beatae id? Quaerat, quod? Consequatur officia est cum quasi at laboriosam odio voluptas placeat, illum nostrum earum suscipit modi quis eum animi eius dignissimos nobis, laborum blanditiis.</p>
                                </Grid>
                        </Grid>
                        </Box>
                    </div> */}

                      


                        
                    </Grid>
            
                </div>

            </FuseScrollbars>
        </div>

        <div>
            
        </div>
       </>
    );
}

export default AssetDetailsV4;